<template>
    <div class="ReferralList">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h2><font-awesome-icon :icon="['fa', 'tower-cell']" /> Unlinked Inquiries <span v-b-tooltip.hover title="Add Inquiry" style="float:right;"><font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddRecord()" class="olive-green-text pointer" /></span></h2>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <GenericDataTable ref="datatable"
                                  @recordclicked="OnRecordClicked"
                                  :table-fields="Fields"
                                  :data-filters="Filters"
                                  :table-slots="Slots"
                                  data-endpoint="StrongFamilies/Referrals/UnlinkedInquiries"
                                  data-method="GET"
                                  :load-indicator="true"
                                  :data-commit-name="null" 
                                  :load-data-on-mounted="false"/>
                </div>
            </div>
        </div>
        <NewReferral ref="component-add-record" @updatetable="OnUpdateTable" />
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPeopleGroup } from '@fortawesome/free-solid-svg-icons';
    library.add(faPeopleGroup);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);

    import GenericDataTable from '../../../Core/UI/GenericDataTable.vue';
    import NewReferral from './NewReferral.vue';

    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        name: "ReferralList",
        created() {
            EventBus.$on('global-update-initiated', this.OnUpdateTable);
        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
        },
        props: [],
        data: function () {
            return {
                //DATA TABLE CONFIGURATION
                Fields: [
                    {
                        name: '__slot:OpenProfile',
                        title: 'Family',
                        sortField: 'Name',
                    },
                    {
                        name: 'Name',
                        title: 'Name',
                        sortField: 'Name',
                        visible: false
                    },
                    {
                        name: 'InquiryDate',
                        title: 'Inquiry Date',
                        sortField: 'InquiryDate',
                        callback: 'formatDate|MM/DD/YY'
                    },
                    {
                        name: 'Territory',
                        title: 'Territory',
                        sortField: 'Territory'
                    },
                    {
                        name: 'Location',
                        title: 'Location',
                        sortField: 'Location'
                    },
                    {
                        name: 'Source',
                        title: 'Source',
                        sortField: 'Source'
                    },
                    {
                        name: 'Status',
                        title: "Status",
                        sortField: 'Status'
                    }
                ],
                Filters: [
                    {
                        Name: "Status",
                        Label: "Status",
                        Options: [
                            {
                                text: "Inquiries",
                                value: "Inquiry"
                            },
                            {
                                text: "Closed Inquiries",
                                value: "Inquiry Closed"
                            }
                        ],
                        Value: "Inquiry"
                    },
                    {
                        Name: "SubProgramID",
                        Label: "Program",
                        Options: [

                        ],
                        Value: ""
                    },
                    {
                        Name: "SubProgramTerritoryID",
                        Label: "Territory",
                        Options: [

                        ],
                        Value: null
                    },
                ],
                Slots: [
                    {
                        Name: "OpenProfile",
                        DisplayProperty: "Name",
                        EventName: "recordclicked"
                    }
                ]
            };
        },
        methods: {
            //UI
            ShowAddRecord() {
                this.$refs["component-add-record"].ShowModal();
            },
            OnUpdateTable() {
                this.$refs["datatable"].GetData();
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OnRecordClicked(rowData) {
                this.$store.commit("CommunityFamilyReferrals.Profiles.Append", rowData);
                this.$parent.ChangePaneShown(rowData.Id);
            }
        },
        components: {
            GenericDataTable,
            NewReferral
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
        },
        mounted() {
            //Seed Sub Program Options
            if (this.SubProgramOptions.length > 0) {
                this.Filters[1].Value = this.SubProgramOptions[0].value;
            }
            this.Filters[1].Options = this.SubProgramOptions;

            //Seed SubProgram Territory Options
            this.Filters[2].Options = this.SubProgramTerritoryOptions;
            this.Filters[2].Options.push({ text: "All", value: null })

            this.OnUpdateTable();
        }
    }
</script>

<style scoped>
</style>